import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5513/api";

/**
 * Obtiene la versión actual de la aplicación
 * Esta ruta es pública y no requiere autenticación
 */
export const getCurrentVersion = async () => {
  try {
    const response = await axios.get(`${API_URL}/version`);
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener versión:", error);
    // Retornar versión por defecto si falla
    return {
      versionString: "1.0.0",
      majorVersion: 1,
      minorVersion: 0,
      patchVersion: 0
    };
  }
};

/**
 * Obtiene el historial de versiones
 * Requiere autenticación
 */
export const getVersionHistory = async (limit = 10) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/version/history`, {
      params: { limit },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.data;
  } catch (error) {
    console.error("Error al obtener historial de versiones:", error);
    throw error.response?.data?.message || "Error al obtener historial de versiones";
  }
};

/**
 * Crea una nueva versión
 * Requiere autenticación
 * @param {string} versionType - 'major', 'minor' o 'patch'
 * @param {string} deployedBy - Usuario que despliega
 * @param {string} deploymentNotes - Notas del despliegue
 */
export const createNewVersion = async (versionType, deployedBy = null, deploymentNotes = null) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API_URL}/version`,
      {
        versionType,
        deployedBy,
        deploymentNotes
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error al crear nueva versión:", error);
    throw error.response?.data?.message || "Error al crear nueva versión";
  }
};
